import Vue from 'vue';
import Vuex from 'vuex';

//Admin
import login from './login';
import admin from './admin';
import user from './user';
import filings from './filings';
import filing from './filing';

//Pages
import filerInformation from './filerInformation';

//Forms
import directorships from './directorships';
import incomeSources from './incomeSources';
import gifts from './gifts';
import creditors from './creditors';
import businessInterest from './businessInterest';
import businessInterestTransfer from './businessInterestTransfer';
import realEstate from './realEstate';
import family from './family';
import msal from './msal';

import reports from './reports';

import pdfGen from './pdfGen';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    msal,
    admin,
    user,
    filings,
    filing,
    login,
    filerInformation,
    directorships,
    incomeSources,
    gifts,
    creditors,
    businessInterest,
    businessInterestTransfer,
    realEstate,
    family,
    pdfGen,
    reports,
  },
  state: {
    app: {
      header: {
        title: 'Financial Disclosure',
        logoImage: {
          src: '/images/city-of-philadelphia-yellow-white.png',
          alt: 'City of Philadelphia logo',
          width: 190,
        },
        fluid: false,
      },
      footer: {
        links: [
          {
            type: 'native',
            text: 'Terms of use',
            href: 'https://www.phila.gov/terms-of-use/',
            attrs: {
              target: '_blank',
            },
          },
        ],
      },
    },
    loading: false,
    doingAjax: true,
    fullScreenLoading: true,
    isLoading: true,
    currentFiling: {
      year: '',
    },
    formFullNames: {
      state: 'Commonwealth of PA Statement of Financial Interests',
      city: 'City of Philadelphia Statement of Financial Interests',
      mayor: `Mayor's Executive Order Financial Disclosure Statement`,
    },
    formNumbers: {
      state: 'SEC-1 (Rev: 01/17)',
      city: '82-S-92',
      mayor: '82-S-92B',
    },
    endpoints: {
      users: '/users',
      filings: '/filings',
      controlValue: '/admin/control-value',
      forgotPassword: '/forgot-password',
      updatePassword: '/update-password',
      resendConfirmationEmail: '/resend-confirm-email',
      accountConfirmation: '/account-confirmation',
      validateToken: '/validate-token',
      resetPassword: '/reset-password',
      admin: {
        users: 'admin/users',
        usersSearch: 'admin/users/search',
        reports: {
          stats: 'admin/reports/filers-stats',
          filersStatus: 'admin/reports/filers-status',
          filingsByYear: 'admin/reports/filings-by-year',
        },
      },
    },
  },
  getters: {},
  mutations: {
    loading (state, status) {
      state.loading = status;
    },
    setFullScreenLoading(state, status) {
      state.fullScreenLoading = status;
    },
    setDoingAjax(state, b) {
      state.doingAjax = b;
    },
    setLoadingStatus(state, payload) {
      state.isLoading = payload;
    },
  },
  actions: {
    setLoadingStatus ({ commit }, payload) {
      commit('setLoadingStatus', payload);
    },
    // eslint-disable-next-line no-unused-vars
    strToNum ({ commit }, { items, keys }) {
      //If not array, just assume keys is string to be parsed
      if (!Array.isArray(items)) {
        return Number(keys);
      }
      items.forEach(item => {
        if (typeof item === 'object') {
          Object.keys(item).forEach(key => {
            if (item[key] && keys.includes(key)) {
              if (item[key] === '') {
                item[key] === null;
              } else {
                item[key] = Number(item[key]);
              }
            }
          });
        }
      });
      return items;
    },
  },
});
